import {footerManagementData} from 'content/footer'

import classes from './styles.module.css'
import Image from 'next/image'
import Link from 'next/link'
import clsx from 'clsx'
export default function Management() {
  return (
    <div className={classes.container}>
      <h2 className={clsx('header2', classes.header)}>{footerManagementData.title}</h2>
      <p className={classes.desc}>{footerManagementData.desc}</p>
      <section className={classes.cardContainer}>
        {footerManagementData.cards.map((card, i) => (
          <div key={i} className={classes.singleCard} style={{background: card.bgColor}}>
            <Image className={classes.cardImage} src={card.icon} alt="management" />
            <h4 className={classes.cardTitle} style={{maxWidth: i === 0 ? '260px' : 'auto'}}>
              {card.title}
            </h4>
            <Link href={card.btnUrl} target="_blank" className={classes.cardBtn}>
              <p> {card.btnText}</p>
            </Link>
          </div>
        ))}
      </section>
    </div>
  )
}
